"use client";

import { DoorOpen, Fence, Hammer, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpecializedServices() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const services = [{
    number: "SERVICE / CNC RETROFITTING",
    title: "CNC Retrofitting",
    description: "Complete modernization of legacy machinery with state-of-the-art Siemens Sinumerik controllers. We restore precision and extend operational life.",
    leadTime: "4-8 weeks",
    Icon: Hammer
  }, {
    number: "SERVICE / FIELD MAINTENANCE",
    title: "Field Maintenance",
    description: "On-site technical support and diagnostic services for industrial automation systems. Expert troubleshooting for Siemens, Heidenhain, and Fanuc.",
    leadTime: "24-48 hours",
    Icon: Sparkles
  }, {
    number: "SERVICE / SPARE PARTS",
    title: "Siemens Spare Parts",
    description: "Direct procurement of critical Siemens components, from servo drives to PLC modules. Guaranteed authentic parts for industrial reliability.",
    leadTime: "1-2 weeks",
    Icon: DoorOpen
  }, {
    number: "SERVICE / SYSTEM INTEGRATION",
    title: "System Integration",
    description: "Custom engineering solutions for complex industrial workflows. We bridge the gap between mechanical hardware and digital control logic.",
    leadTime: "6-12 weeks",
    Icon: Fence
  }];
  return <section data-section-id="4776" id="specialized-services" className="bg-background text-foreground py-24 md:py-32 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={header.ref} className={`mb-16 md:mb-24 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="font-mono text-xs tracking-widest text-muted-foreground mb-8 uppercase">— SPECIALIZED SERVICES</div>
          <h2 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tighter text-foreground font-bold">
            Precision logic.
            <br />
            <span className="text-primary">Industrial excellence.</span>
          </h2>
        </div>

        {}
        <div ref={grid.ref} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, i) => {
          const Icon = service.Icon;
          return <div data-index={i} key={service.number} className={`group relative bg-card border border-border p-8 md:p-10 flex flex-col transition-all duration-700 ease-out hover:-translate-y-1 hover:border-primary rounded-md ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: grid.isVisible ? `${i * 120}ms` : "0ms"
          }}>
                {}
                <div className="font-mono text-[10px] sm:text-xs tracking-widest text-muted-foreground uppercase">
                  {service.number}
                </div>

                {}
                <div className="mt-10 md:mt-12">
                  <Icon strokeWidth={1.5} className="w-12 h-12 md:w-14 md:h-14 text-primary transition-all duration-500 group-hover:scale-110" />
                </div>

                {}
                <h3 className="mt-8 md:mt-10 font-default text-3xl sm:text-4xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-foreground font-bold">
                  {service.title}
                </h3>

                {}
                <p className="mt-5 font-default text-sm md:text-base leading-relaxed text-muted-foreground max-w-md">
                  {service.description}
                </p>

                {}
                

                {}
                
              </div>;
        })}
        </div>

        {}
        <div ref={cta.ref} className={`mt-20 md:mt-28 border-t border-b border-border py-12 md:py-16 transition-all duration-1000 ease-out ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link to="/ContactUsPage" className="group block text-center font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tighter text-foreground hover:text-primary transition-colors duration-500 font-bold">Ready to optimize your production? <br />Let's talk &nbsp;<span className="inline-block text-primary group-hover:translate-x-2 transition-all duration-500" data-ast-id="f:/src/pages/About/sections/SpecializedServices.tsx|sig:gsu1zb" data-ast-start="4605" data-ast-end="4739">→</span></Link>
        </div>
      </div>
    </section>;
}